import Defs from '../../../../../includes/primitives/colorDefs'
import CONST from '../../../../../includes/primitives/_constant_demo'

export default {
  data: () => ({

    HOST: CONST.HOST_NAME_RESOURCE + '/resources',
        
    canvasForm:     null,
    canvasTimeline: null,
    canvasSkyline:  null,
    canvasLegend:   null,
    canvasDetail:   null,
    canvasExcept:   null,
    canvasFront:    null,

    rawData:        null,

    codes:          null,
    timeline:       null,
    area:           null,
    sheet:          null,
    skyline:        null,
    legend:         null,
    detail:         null,
    search:         null,
    keys:           null,

    current: {},
  }),


  computed: {
    ready2draw() {
      return (
        this.DataItems.length > 0 &&
        Object.keys(this.Canvas).length > 0
      )
    },
  },


  methods: {
    set_Gradients() {
      let lightBlue = this.svg
      .append('defs')
      .append('linearGradient').attr('id', `shadowTimeline`).attr('x1', 0.5).attr('x2', 0.5).attr('y2', 1)
      lightBlue.append('stop').attr('stop-color', '#3d3d3d').attr('offset', '0').attr('stop-opacity', 0.5)
      lightBlue.append('stop').attr('stop-color', '#fff').attr('offset', '1').attr('stop-opacity', 0.3)

      Defs.setDefs_Gradients(this.svg, '', 'LinearA4', 'LightGray', [ 0.5, 1.0, 0.5, -0.2], this.localId)
      Defs.setDefs_Gradients(this.svg, 'plan', 'LinearA4', 'LightBlue', [.5, .8, .5, 0], this.localId)
    },
  }

}